import { call, put, select, cancelled, fork, take  } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga'
import { updateLoads, saveLoadInfo } from "../actions/Loads";

function createChannel({loadsCollection, email}) {
    var un = () => { }
    return eventChannel(emit => {
      setImmediate(() => {
        if(email === "admin@wheeling.com"){
          un = loadsCollection.orderBy("timestamp_beginning", "desc").onSnapshot((snapshot) => {
            emit(snapshot);
          })
        }else{
          var c = "";
          if(email === "admin@bird.com"){
            c = "Bird";
          }else if(email === "admin@lime.com"){
            c = "Lime";
          }
          un = loadsCollection.where("company", "==", c).orderBy("timestamp_beginning", "desc").onSnapshot((snapshot) => {
            emit(snapshot);
          })
        }
      });
      const unsubs = () => {
        un();
      }
      return unsubs;
    });
}

function* subscribeToEvent(collection, callback) {
  let channel;
  try {
    channel = yield call(createChannel, collection);
  } catch (chanErr) {
    console.tron.error(`Error creating subscription channel for event`, chanErr);
    throw chanErr;
  }

  while (true) {
    try {
      const data = yield take(channel);
      yield fork(callback, data);
    } catch (err) {
      if (yield cancelled()) {
        channel.close();
        return;
      } else {
        console.tron.error(`Error in saga task for event`, err);
      }
    }
  }
}

export function* initialize(){
    const { firebase: {loadsCollection }, session: {user}} = yield select(state => state);
    if(user){
      yield fork(subscribeToEvent, {loadsCollection, email: user.email}, function* (snapshot) {
        var data = [], k = 1;
        const { stations: { data: stationData } } = yield select(state => state);
        
        snapshot.docs.forEach((v) => {
            let obj = v.data();
            const station = stationData.find(async s => await s.name_doc_id === obj.station);
            obj.name = station.name;
            obj.city = station.city;
            obj.incremental = station.incremental;

            data.push({
                id: k,
                name_doc_id: v.id,
                ...obj
            })
            k++
        })
        yield put({
            type: updateLoads,
            payload: data
        })
      })
    }

}
//Obtiene la info de una carga para renderizarla
export function* getLoadInfo(action){
    const {firebase} = yield select(state => state)
    var doc_name_id = action.payload.data
    const doc_load = yield call([firebase.loadsCollection, firebase.loadsCollection.doc], doc_name_id);
    const docGet = yield call([doc_load, doc_load.get])
    var payload = {...docGet.data(), doc_name_id}
    yield put({type: saveLoadInfo, payload})
}